import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { selectEntityClientFields } from 'src/selectors/dynamicFields.selector'
import { fetchDynamicFieldsByEntityClient } from 'src/actions/dynamicfield.actions'
import { useDynamicFields } from 'src/components/CompanyDynamicFields/hook/useDynamicFields'

export const useClientDynamicField = (
  init: boolean,
  withValues?: DynamicFieldRequest[],
) => {
  const dispatch = useDispatch()

  const entityFields = useSelector(selectEntityClientFields)

  useEffect(() => {
    if (!init) return
    dispatch(fetchDynamicFieldsByEntityClient())
  }, [init])

  return useDynamicFields(entityFields, withValues)
}
